import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import * as S from './SectionModulosBioAtlas.styles'

const MODULOS = [
  { nome: 'Histologia', img: 'histologia.png', key: 'histologia' },
  { nome: 'Patologia', img: 'patologia.png', key: 'patologia' },
  { nome: 'Histopatologia', img: 'histopatologia.png', key: 'histopatologia' },
  { nome: 'Radiologia', img: 'radiologia.png', key: 'radiologia' },
  { nome: 'Fisiologia', img: 'fisiologia.png', key: 'fisiologia' },
  { nome: 'Embriologia', img: 'embriologia.png', key: 'embriologia' },
  { nome: 'Citologia', img: 'citologia.png', key: 'citologia' },
  {
    nome: 'Anatomia Topográfica',
    img: 'anatomia-topografica.png',
    key: 'anatomiaTopografica'
  },
  {
    nome: 'Anatomia Sistêmica',
    img: 'anatomia-sistemica.png',
    key: 'anatomiaSistemica'
  },
  {
    nome: 'Anatomia Completa',
    img: 'anatomia-completa.png',
    key: 'anatomiaCompleta'
  }
]

const settings = {
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  slidesToShow: 5.2, // 5 inteiros + 6º parcialmente visível
  slidesToScroll: 1,
  infinite: true,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 900, settings: { slidesToShow: 3 } },
    { breakpoint: 600, settings: { slidesToShow: 2 } }
  ]
}

const SectionModulosBioAtlas = () => {
  const { t } = useTranslation()

  return (
    <S.Section>
      <S.Title>{t('landingV2.sectionModulosBioAtlas.title')}</S.Title>
      <S.CarouselWrapper>
        <Slider {...settings}>
          {MODULOS.map((modulo, idx) => (
            <S.Item key={modulo.key}>
              <S.ItemTitle>
                {t(`landingV2.sectionModulosBioAtlas.modules.${modulo.key}`)}
              </S.ItemTitle>
              <S.ItemImageWrapper>
                {modulo.img ? (
                  <Image
                    src={`/assets/images/modulos/${modulo.img}`}
                    alt={t(
                      `landingV2.sectionModulosBioAtlas.modules.${modulo.key}`
                    )}
                    width={modulo.nome === 'Histopatologia' ? 120 : 160}
                    height={modulo.nome === 'Histopatologia' ? 120 : 160}
                    style={{ maxWidth: '100%', height: 'auto', width: 'auto' }}
                    priority={idx < 6}
                    className="modulo-img"
                  />
                ) : (
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      background: '#eee',
                      borderRadius: 12,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#bbb',
                      fontSize: 14
                    }}
                  >
                    {t('landingV2.sectionModulosBioAtlas.fallbackText')}
                  </div>
                )}
              </S.ItemImageWrapper>
              <S.HoverOverlay className="hover-overlay">
                <S.HoverButton>
                  {t('landingV2.sectionModulosBioAtlas.knowMore', 'Saber mais')}
                </S.HoverButton>
              </S.HoverOverlay>
            </S.Item>
          ))}
        </Slider>
      </S.CarouselWrapper>
      <style>{`
        @media (max-width: 600px) {
          .modulo-img {
            width: 80px !important;
            height: auto !important;
            display: block;
            margin: 0 auto;
          }
        }
      `}</style>
    </S.Section>
  )
}

export default SectionModulosBioAtlas
